import { AiOutlineArrowLeft, } from "react-icons/ai";
import { GrLinkNext } from "react-icons/gr";

export const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return(
      <div onClick={onClick} className={`${className}`} >
        <AiOutlineArrowLeft className="arrows" />
      </div>
    )
    }

export function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return(
      <div onClick={onClick} className={`${className}`} >
        <GrLinkNext className="arrows"/>
      </div>
    )
  }